export const AnalyticsRange = {
	DAILY: 'DAILY',
	WEEKLY: 'WEEKLY',
	MONTHLY: 'MONTHLY',
	QUARTERLY: 'QUARTERLY',
	ANNUALLY: 'ANNUALLY',
};
